import { Stack, Typography } from "@mui/material";
import CenteredAuthenticatedLayout from "layouts/CenteredAuthenticated/CenteredAuthenticatedLayout";
import { centeredPageGutterSx } from "layouts/CenteredAuthenticated/CenteredPage.tokens";
import React from "react";
import { useTitle } from "utils/UseTitle";
import title from "global/constants/TitleConstants";

const Configurations = () => {
  useTitle(title.CONFIGURATION);
  const getPage = () => {
    // The desktop gutter every centred page shares — see
    // `CenteredPage.tokens`.
    return (
      <Stack spacing={3} sx={centeredPageGutterSx}>
        <Typography component="h1" variant="h5">
          Configurations
        </Typography>
      </Stack>
    );
  };

  return <CenteredAuthenticatedLayout>{getPage()}</CenteredAuthenticatedLayout>;
};

export default Configurations;
